import * as React from "react";
import { IButtonEvents } from "../_common/buttonEvents";
import { Icon } from "../IconSVG";
import { IIconSVG } from "../IconSVG";
import { Wrapper } from "./components/Wrapper";

export interface IKeypadButton extends IButtonEvents, IIconSVG {
  disabled?: boolean;
}

export const KeypadButton = ({ type, active, ...props }: IKeypadButton) => (
  <Wrapper {...props}>
    <Icon type={type} active={active} />
  </Wrapper>
);
